module.exports = __webpack_public_path__ + "static/media/promo-key-heart.d55efcf4.svg";